import styled from "@emotion/styled";

import { colors } from "../../colors";
import type { StyledPostItemProps, StyledPostListProps } from "./types";

/**
 * Styled container for post list
 *
 * @since 1.0.0
 */
export const StyledPostList = styled.div<StyledPostListProps>`
  display: flex;
  flex-direction: column;
  gap: 10px;

  ${({ $styleProps }) =>
    $styleProps &&
    `
    ${$styleProps.backgroundColor ? `background-color: ${$styleProps.backgroundColor};` : ""}
    ${$styleProps.padding ? `padding: ${$styleProps.padding};` : ""}
    ${$styleProps.borderRadius ? `border-radius: ${$styleProps.borderRadius};` : ""}
    ${$styleProps.gap ? `gap: ${$styleProps.gap};` : ""}
  `}
`;

/**
 * Styled post item wrapper
 *
 * @since 1.0.0
 */
export const StyledPostItem = styled.div<StyledPostItemProps>`
  ${({ $styleProps }) =>
    $styleProps &&
    `
    ${$styleProps.backgroundColor ? `background-color: ${$styleProps.backgroundColor};` : ""}
    ${$styleProps.borderColor ? `border-color: ${$styleProps.borderColor};` : ""}
    ${$styleProps.padding ? `padding: ${$styleProps.padding};` : ""}
    ${$styleProps.borderRadius ? `border-radius: ${$styleProps.borderRadius};` : ""}
  `}
`;

/**
 * Styled title
 *
 * @since 1.0.0
 */
export const Title = styled.h3<StyledPostItemProps>`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: ${colors.gray[900]};
  display: flex;
  align-items: center;
  gap: 10px;

  ${({ $styleProps }) =>
    $styleProps &&
    `
    ${$styleProps.titleColor ? `color: ${$styleProps.titleColor};` : ""}
    ${$styleProps.titleFontSize ? `font-size: ${$styleProps.titleFontSize};` : ""}
    ${$styleProps.titleFontWeight ? `font-weight: ${$styleProps.titleFontWeight};` : ""}
  `}
`;

/**
 * Styled title link
 *
 * @since 1.0.0
 */
export const TitleLink = styled.span`
  cursor: pointer;
  color: inherit;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: ${colors.primary[300]};
  }
`;

/**
 * Styled modified date
 *
 * @since 1.0.0
 */
export const ModifiedDate = styled.p<StyledPostItemProps>`
  margin: 5px 0 0 0;
  font-size: 13px;
  color: ${colors.gray[600]};

  ${({ $styleProps }) =>
    $styleProps &&
    `
    ${$styleProps.dateColor ? `color: ${$styleProps.dateColor};` : ""}
    ${$styleProps.dateFontSize ? `font-size: ${$styleProps.dateFontSize};` : ""}
  `}
`;
